













import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { StaffMember } from 'frontend/types/about';

@Component({
  components: {},
  computed: {},
})
export default class StaffMemberItem extends Vue {
  @Prop() staffMember!: StaffMember;
}
